"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _IndexProvider = _interopRequireDefault(require("./IndexProvider"));
var _classes = require("./classes");
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "onRowsScrollEnd", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var TableBody = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
    onRowsScrollEnd = _ref.onRowsScrollEnd,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var observerElem = (0, _react.useRef)(null);
  var handleObserver = (0, _react.useCallback)(function (entries) {
    var _entries = _slicedToArray(entries, 1),
      target = _entries[0];
    if (target.isIntersecting) {
      onRowsScrollEnd();
    }
  }, [onRowsScrollEnd]);
  (0, _react.useEffect)(function () {
    if (onRowsScrollEnd) {
      var element = observerElem.current;
      var option = {
        threshold: 0
      };
      var observer = new IntersectionObserver(handleObserver, option);
      observer.observe(element);
      return function () {
        return observer.unobserve(element);
      };
    }
  }, [onRowsScrollEnd, handleObserver]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_IndexProvider["default"], {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableBody["default"], _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      className: (0, _clsx["default"])(className, _classes.STICKY_TABLE_BODY),
      "data-cy": 'TableBody',
      children: children
    })), onRowsScrollEnd ? /*#__PURE__*/(0, _jsxRuntime.jsx)("tfoot", {
      ref: observerElem,
      style: {
        height: '1px'
      }
    }) : null]
  });
});
TableBody.propTypes = {
  className: _propTypes["default"].string,
  /**
   * The content of the component, normally TableRow.
   */
  children: _propTypes["default"].node,
  /**
   *	Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * 	The component used for the root node. Either a string to use a HTML element or a component.
   */
  component: _propTypes["default"].elementType
};
var _default = exports["default"] = TableBody;